// Library Class
import * as $ from 'jquery';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
// Service Class
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { ExcelService } from './../../../../services/infrastructure/excel.service';
import { CommonService } from './../../../../services/common/common.service';
import { ReleaseItemsAuditService } from './../../../../services/seed/reports/release-items-audit.service';
// Class
import { MasterConstants } from './../../../../common/constants/master-constants';
import { ReleaseItemsAuditLogFilter } from './../../../../models/ReleaseItemsAuditLogFilter';
import { CommonDDL } from '../../../../models/CommonDDL';
import { Subscription } from 'rxjs';
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-release-items-audit',
  templateUrl: './release-items-audit.component.html',
  styleUrls: ['./release-items-audit.component.scss']
})
export class ReleaseItemsAuditComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscription = new Array<Subscription>();

  @ViewChild('productPaginator', { read: MatPaginator }) productPaginator: MatPaginator;
  @ViewChild('productTable', { read: MatSort }) productSort: MatSort;

  // Common
  headerYear: any;
  headerCompany = MasterConstants.US_COMPANYCODE;

  // Account Dropdown
  ddlAccounts: any;
  accountsLoading = false;
  selectedAccount: any;

  // Filter
  selectedValue: string;
  isTextBoxEmpty = true;
  productFilters: any;
  filterValueList = new Array();
  previousSelectedValue: string;
  searchValue = '';
  partialSearchValue = '';
  // productMasterList: any = [];
  marketingMasterList: any = [];
  seedsizeMasterList: any = [];
  packagesizeMasterList: any = [];
  technologyMasterList: any = [];
  treatmentMasterList: any = [];
  productLineMasterList: any = [];
  branchPlantMasterList: any = [];
  requestTypeMasterList: any = [];
  explanationList: any = [];
  isEvolveAccountRestriction = false;
  evolveUserId = '';
  accountNoList: any = [];
  orderNoList: any = [];
  releaseItemsAuditDataSource: any;
  releaseItemsAuditList: any = [];
  fromDateFilter: any;
  toDateFilter: any;
  filter: ReleaseItemsAuditLogFilter = new ReleaseItemsAuditLogFilter();

  comparisonType: any[] = [{ value: '<' }, { value: '>' }, { value: '=' }, { value: '>=' }, { value: '<=' }, { value: '<>' }];
  displayedColumns: string[] = ['itemDescription', 'itemNumber', 'auditTime', 'releaseID', 'accountName', 'accountNumber', 'city', 'quantity', 'changeQty', 'updatedBy',
    'branch', 'requestType', 'explanation', 'action', 'dotTransactionId', 'erpOrderNumber', 'seedSizeDescription', 'packageSizeDescription', 'treatmentDescription'];

  searchTypeList: string[] = [];

  constructor(
    private localStorageService: LocalStorageService,
    private loaderService: LoaderService,
    private datePipe: DatePipe,
    private excelService: ExcelService,
    private commonService: CommonService,
    private releaseItemsAuditService: ReleaseItemsAuditService,
    private toastrService: ToastrService) {
    this.filter.changeQtyAction = '<';
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccSummaryTableHeight();
  }

  ngOnInit() {
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    this.loadMasterData();
    this.resetAuditFilter();
    this.getEvolveAccess();
    this.setSearchTypeList();
    this.selectedValue = this.searchTypeList[0];
  }

  setSearchTypeList() {
    if (this.isEvolveAccountRestriction) {
      this.getAccountList();
      this.searchTypeList = ['Product Name', 'Item Number', 'Account', 'City', 'Product Line', 'Release Number', 'Change Quantity', 'Duration', 'User ID', 'Marketing Brand', 'Seed Size', 'Package Size', 'Technology', 'Treatment', 'Branch Plant', 'Request Type', 'Explanation', 'DOTTransaction ID', 'ERP Order Number'];
    }
    else {
      this.searchTypeList = ['Product Name', 'Item Number', 'Account No', 'Account Name', 'City', 'Product Line', 'Release Number', 'Change Quantity', 'Duration', 'User ID', 'Marketing Brand', 'Seed Size', 'Package Size', 'Technology', 'Treatment', 'Branch Plant', 'Request Type', 'Explanation', 'DOTTransaction ID', 'ERP Order Number'];
    }
  }

  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  getEvolveAccess() {
    const validateEvolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
    const sessionData = validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
    this.isEvolveAccountRestriction = sessionData.evolveAccountRestriction;
    this.filter.evolveAccountRestriction = sessionData.evolveAccountRestriction;
    this.filter.userId = sessionData.userId;
    this.evolveUserId = sessionData.userId;
  }

  // Bind Account list
  getAccountList() {
    this.accountsLoading = true;
    this.subscription.push(this.releaseItemsAuditService.getReleaseItemsAuditAccountList().subscribe((result: any[]) => {
      this.ddlAccounts = result;
      this.accountsLoading = false;
    }, error => LolLoggerService.error(error)));
  }

  // Enable Disable Search
  enableDisableSearch() {
    if (this.validateFilter(this.productFilters)) {
      this.isTextBoxEmpty = false;
    }
    else {
      this.isTextBoxEmpty = true;
    }
  }

  // Validate Brand Search
  validateBrandSearch() {
    // To Validate Brand
    if (this.productFilters.Brand !== null
      && this.productFilters.Brand !== ''
      && this.productFilters.Brand.toString().trim().length >= 2) {
      this.isTextBoxEmpty = false;
    }
    else {
      this.isTextBoxEmpty = true;
    }
  }

  // Validate Technology Search
  validateTechnologySearch() {
    // To Validate Technology
    if (this.productFilters.TechnologyList !== null
      && this.productFilters.TechnologyList !== ''
      && this.productFilters.TechnologyList.toString().trim().length >= 2) {
      this.isTextBoxEmpty = false;
    }
    else {
      this.isTextBoxEmpty = true;
    }
  }

  // to validate filter
  validateFilter(productFilter) {
    let isValid = false;

    // To Validate Brand
    if (productFilter.Brand !== null && productFilter.Brand !== '' && productFilter.Brand.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate MarketingBrand
    if (productFilter.MarketingBrandList != null && productFilter.MarketingBrandList.length > 0) {
      isValid = true;
    }

    // To Validate SeedSize
    if (productFilter.SeedSizeList != null && productFilter.SeedSizeList.length > 0) {
      isValid = true;
    }

    // To Validate PackageSize
    if (productFilter.PackageSizeList != null && productFilter.PackageSizeList.length > 0) {
      isValid = true;
    }

    // To Validate Technology
    if (productFilter.TechnologyList != null && productFilter.TechnologyList !== '' && productFilter.TechnologyList.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate Treatment
    if (productFilter.TreatmentList != null && productFilter.TreatmentList.length > 0) {
      isValid = true;
    }

    // To Validate BranchPlant
    if (productFilter.BranchPlantList != null && productFilter.BranchPlantList.length > 0) {
      isValid = true;
    }

    // To Validate RequestType
    if (productFilter.RequestTypeList != null && productFilter.RequestTypeList.length > 0) {
      isValid = true;
    }

    // To Validate Explanation
    if (productFilter.ExplanationList != null && productFilter.ExplanationList.length > 0) {
      isValid = true;
    }

    // To Validate From Date
    if (productFilter.FromDate != null) {
      isValid = true;
    }

    // To Validate To Date
    if (productFilter.ToDate != null) {
      isValid = true;
    }

    // To Validate ProductLine
    if (productFilter.ProductLineList != null && productFilter.ProductLineList.length > 0) {
      isValid = true;
    }
    if (productFilter.Brand == null
      && (productFilter.MarketingBrandList == null || productFilter.MarketingBrandList.length <= 0)
      && (productFilter.SeedSizeList == null || productFilter.SeedSizeList.length <= 0)
      && (productFilter.PackageSizeList == null || productFilter.PackageSizeList.length <= 0)
      && (productFilter.TechnologyList == null)
      && (productFilter.TreatmentList == null || productFilter.TreatmentList.length <= 0)
      && (productFilter.ProductLineList == null || productFilter.ProductLineList.length <= 0)
      && (productFilter.BranchPlantList == null || productFilter.BranchPlantList.length <= 0)
      && (productFilter.RequestTypeList == null || productFilter.RequestTypeList.length <= 0)
      && (productFilter.ExplanationList == null || productFilter.ExplanationList.length <= 0)
      && (productFilter.FromDate == null)
      && (productFilter.ToDate == null)
    ) {
      isValid = false;
    }
    return isValid;
  }

  validateInputText() {
    const accountRegx = RegExp('^[0-9, ]+$');
    const changeQtyRegx = RegExp('^[0-9]+$');
    return ((this.productFilters.TxtAccountNo ? accountRegx.test(this.productFilters.TxtAccountNo) : true) &&
      (this.productFilters.ChangeQty ? changeQtyRegx.test(this.productFilters.ChangeQty) : true));
  }

  // Keep Filter Value
  keepFilter(selectedObj: any, type: string) {
    if (!this.validateInputText()) {
      this.toastrService.error('Invalid Input.');
      return false;
    }

    if (this.filterValueList) {
      let selectedIds = '';
      if (selectedObj && selectedObj.selectedValues) {
        const selectedValues = selectedObj.selectedValues as any[];
        selectedValues.forEach(x => { selectedIds = selectedIds + (type == 'AccountNo' ? x.accountNumber : x.id) + ','; });
      }

      switch (type) {
        case 'MarketingBrand':
          this.filter.marketingBrand = selectedIds;
          break;
        case 'SeedSize':
          this.filter.seedSize = selectedIds;
          break;
        case 'PackageSize':
          this.filter.packageSize = selectedIds;
          break;
        case 'Technology':
          this.filter.technology = selectedIds;
          break;
        case 'Treatment':
          this.filter.treatment = selectedIds;
          break;
        case 'ProductLine':
          this.filter.productLine = selectedIds;
          break;
        case 'ItemNo':
          this.filter.itemNo = selectedIds;
          break;
        case 'BranchPlant':
          this.filter.branchPlant = selectedIds;
          break;
        case 'RequestType':
          this.filter.requestType = selectedIds;
          break;
        case 'Explanation':
          this.filter.explanation = selectedIds;
          break;
      }

      // Create filterValueList from Product Filters
      this.filterValueList = [];
      if (this.productFilters) {
        if (this.productFilters.Brand && this.productFilters.Brand != '') {
          this.filterValueList.push('Product Name : ' + this.productFilters.Brand);
          this.filter.productName = this.productFilters.Brand;
        }
        // Set Item No
        if (this.productFilters.ItemNo && this.productFilters.ItemNo.length > 0) {
          var strMB = '';
          this.productFilters.ItemNo.forEach(x => {
            strMB = strMB + x + ', ';
          });
          this.filterValueList.push('Item No : ' + strMB.substr(0, strMB.length - 2));
        }
        // Set Order No
        if (this.productFilters.OrderNo && this.productFilters.OrderNo != '') {
          this.filterValueList.push('Order No : ' + this.productFilters.OrderNo);
          this.filter.orderNo = this.productFilters.OrderNo;
        }

        // Set change Qty
        if (this.productFilters.ChangeQty && this.productFilters.ChangeQty != '' && this.filter.changeQtyAction) {
          this.filterValueList.push('Change Qty : ' + this.filter.changeQtyAction + ' ' + this.productFilters.ChangeQty);
          this.filter.changeQty = this.productFilters.ChangeQty;
        }
        if (this.productFilters.MarketingBrandList && this.productFilters.MarketingBrandList.length > 0) {
          var strMB = '';
          this.productFilters.MarketingBrandList.forEach(x => {
            strMB = strMB + x + ', ';
          });
          this.filterValueList.push('Marketing Brand : ' + strMB.substr(0, strMB.length - 2));
        }
        if (this.productFilters.SeedSizeList && this.productFilters.SeedSizeList.length > 0) {
          let strSS = '';
          this.productFilters.SeedSizeList.forEach(x => {
            strSS = strSS + x + ', ';
          });
          this.filterValueList.push('Seed Size : ' + strSS.substr(0, strSS.length - 2));
        }
        if (this.productFilters.PackageSizeList && this.productFilters.PackageSizeList.length > 0) {
          let strPS = '';
          this.productFilters.PackageSizeList.forEach(x => {
            strPS = strPS + x + ', ';
          });
          this.filterValueList.push('Package Size : ' + strPS.substr(0, strPS.length - 2));
        }
        if (this.productFilters.TechnologyList && this.productFilters.TechnologyList != '') {
          this.filterValueList.push('Technology : ' + this.productFilters.TechnologyList);
          this.filter.technology = this.productFilters.TechnologyList;
        }
        if (this.productFilters.TreatmentList && this.productFilters.TreatmentList.length > 0) {
          let strTreat = '';
          this.productFilters.TreatmentList.forEach(x => {
            strTreat = strTreat + x + ', ';
          });
          this.filterValueList.push('Treatment : ' + strTreat.substr(0, strTreat.length - 2));
        }

        if (this.productFilters.ExplanationList && this.productFilters.ExplanationList.length > 0) {
          let strExpl = '';
          this.productFilters.ExplanationList.forEach(x => {
            strExpl = strExpl + x + ', ';
          });
          this.filterValueList.push('Explanation : ' + strExpl.substr(0, strExpl.length - 2));
        }

        // text Account No
        if (this.productFilters.TxtAccountNo && this.productFilters.TxtAccountNo != '') {
          this.filterValueList.push('Account No : ' + this.productFilters.TxtAccountNo);
          this.filter.account = this.productFilters.TxtAccountNo;
        }
        else if (this.productFilters.AccountNo && this.productFilters.AccountNo.length > 0) {
          let strAct = '';
          this.productFilters.AccountNo.forEach(x => {
            strAct = strAct + x + ', ';
          });

          if (this.isEvolveAccountRestriction) {
            this.filterValueList.push('Account : ' + strAct.substr(0, strAct.length - 2));
          }
          else {
            this.filterValueList.push('Account No : ' + strAct.substr(0, strAct.length - 2));
          }

          selectedIds = '';
          this.accountNoList.forEach(x => {
            if (this.productFilters.AccountNo.indexOf(x.accountNumber) > -1) {
              selectedIds = selectedIds + x.accountNumber + ',';
            }
          });
          if (this.productFilters.AccountNo == -1) {
            this.filter.account = '-1';
          }
          else {
            this.filter.account = selectedIds;
          }
        }
        else {
          this.filter.account = null;
        }

        // Account Name
        if (this.productFilters.AccountName && this.productFilters.AccountName != '') {
          this.filterValueList.push('Account Name : ' + this.productFilters.AccountName);
          this.filter.accountName = this.productFilters.AccountName;
        }
        else {
          this.filter.accountName = null;
        }

        // City
        if (this.productFilters.City && this.productFilters.City != '') {
          this.filterValueList.push('City : ' + this.productFilters.City);
          this.filter.city = this.productFilters.City;
        }
        else {
          this.filter.city = null;
        }

        // DOTTransaction ID
        if (this.productFilters.DOTTransactionID && this.productFilters.DOTTransactionID != '') {
          this.filterValueList.push('DOTTransaction ID : ' + this.productFilters.DOTTransactionID);
          this.filter.dotTransactionID = this.productFilters.DOTTransactionID;
        }
        else {
          this.filter.dotTransactionID = null;
        }

        // DOTTransaction ID
        if (this.productFilters.ERPOrderNumber && this.productFilters.ERPOrderNumber != '') {
          this.filterValueList.push('ERP Order Number : ' + this.productFilters.ERPOrderNumber);
          this.filter.erpOrderNumber = this.productFilters.ERPOrderNumber;
        }
        else {
          this.filter.erpOrderNumber = null;
        }

        // User ID
        if (this.productFilters.UserID && this.productFilters.UserID != '') {
          this.filterValueList.push('User ID : ' + this.productFilters.UserID);
          this.filter.userId = this.productFilters.UserID;
        }
        else {
          this.filter.userId = null;
        }

        if (this.productFilters.ProductLineList && this.productFilters.ProductLineList.length > 0) {
          let strPL = '';
          this.productFilters.ProductLineList.forEach(x => {
            strPL = strPL + x + ', ';
          });
          this.filterValueList.push('Product Line : ' + strPL.substr(0, strPL.length - 2));
        }
        // Branch Plant
        if (this.productFilters.BranchPlantList && this.productFilters.BranchPlantList.length > 0) {
          let strBP = '';
          this.productFilters.BranchPlantList.forEach(x => {
            strBP = strBP + x + ', ';
          });
          this.filterValueList.push('Branch Plant : ' + strBP.substr(0, strBP.length - 2));
        }
        // Request Type
        if (this.productFilters.RequestTypeList && this.productFilters.RequestTypeList.length > 0) {
          let strRQ = '';
          this.productFilters.RequestTypeList.forEach(x => {
            strRQ = strRQ + x + ', ';
          });
          this.filterValueList.push('Request Type : ' + strRQ.substr(0, strRQ.length - 2));
        }
        // Release
        if (this.productFilters.Releases && this.productFilters.Releases != '') {
          this.filterValueList.push('Releases : ' + this.productFilters.Releases);
          this.filter.releases = this.productFilters.Releases;
        }
        else {
          this.filter.releases = null;
        }

        if (this.productFilters.FromDate
          && this.productFilters.FromDate != null
          && this.productFilters.ToDate
          && this.productFilters.ToDate != null) {
          this.filterValueList.push('Duration : (' + this.datePipe.transform(this.productFilters.FromDate, 'MM-dd-yyyy') + ') - (' + this.datePipe.transform(this.productFilters.ToDate, 'MM-dd-yyyy') + ')');
          this.filter.fromDate = new Date(this.productFilters.FromDate).toDateString();
          this.filter.toDate = new Date(this.productFilters.ToDate).toDateString();
        }
      }
    }
    if (this.productFilters && (this.productFilters.Brand != null && this.productFilters.Brand !== '') ||
      (this.productFilters.MarketingBrandList && this.productFilters.MarketingBrandList.length > 0) ||
      (this.productFilters.SeedSizeList && this.productFilters.SeedSizeList.length > 0) ||
      (this.productFilters.PackageSizeList && this.productFilters.PackageSizeList.length > 0) ||
      (this.productFilters.TechnologyList != null && this.productFilters.TechnologyList !== '') ||
      (this.productFilters.TreatmentList && this.productFilters.TreatmentList.length > 0) ||
      (this.productFilters.ProductLineList && this.productFilters.ProductLineList.length > 0) ||
      (this.productFilters.BranchPlantList && this.productFilters.BranchPlantList.length > 0) ||
      (this.productFilters.ExplanationList && this.productFilters.ExplanationList.length > 0) ||
      (this.productFilters.RequestTypeList && this.productFilters.RequestTypeList.length > 0)) {
      this.productFilters = this.getProductFilters(this.productFilters);
    }
    this.enableDisableSearch();
    this.setAccSummaryTableHeight();
    this.previousSelectedValue = this.selectedValue;
    this.searchValue = '';
    this.partialSearchValue = '';
  }

  // Get Product filter
  getProductFilters(productFilter) {
    this.productFilters.CompanyCode = this.headerCompany;
    this.productFilters.CropYear = this.headerYear;
    return productFilter;
  }

  // Load master data
  loadMasterData() {
    // get Item Number List
    this.subscription.push(this.commonService.getItemNumbers().subscribe((result: any) => {
      this.orderNoList = result;
    }));

    // MarketingBrand master data
    if (this.localStorageService.get(MasterConstants.MARKETING_BRAND_MASTER_LIST)) {
      this.marketingMasterList = JSON.parse(this.localStorageService.get(MasterConstants.MARKETING_BRAND_MASTER_LIST));
    }

    // SeedSize master data
    if (this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST)) {
      this.seedsizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST));
    }

    // PackageSize master data
    if (this.localStorageService.get(MasterConstants.PACKAGE_SIZE_MASTER_LIST)) {
      this.packagesizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PACKAGE_SIZE_MASTER_LIST));
    }

    // Technology master data
    if (this.localStorageService.get(MasterConstants.TECHNOLOGY_MASTER_LIST)) {
      this.technologyMasterList = JSON.parse(this.localStorageService.get(MasterConstants.TECHNOLOGY_MASTER_LIST));
    }

    // Treatment master data
    if (this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST)) {
      this.treatmentMasterList = JSON.parse(this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST));
    }

    // ProductLine master data
    if (this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST)) {
      this.productLineMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST));
    }

    // BranchPlant master data
    if (this.localStorageService.get(MasterConstants.BRANCH_PLANT_MASTER_LIST)) {
      this.branchPlantMasterList = JSON.parse(this.localStorageService.get(MasterConstants.BRANCH_PLANT_MASTER_LIST));
    }

    // RequestType master data
    if (this.localStorageService.get(MasterConstants.VERSION_CONTROL_MASTER_LIST)) {
      this.requestTypeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.VERSION_CONTROL_MASTER_LIST));
    }

    // Explanation master data
    if (this.localStorageService.get(MasterConstants.ORDER_CHANGE_CODE_TYPE_MASTER_LIST)) {
      this.explanationList = JSON.parse(this.localStorageService.get(MasterConstants.ORDER_CHANGE_CODE_TYPE_MASTER_LIST));
    }

    this.subscription.push(this.commonService.getReportFilterDDLValues(this.headerYear).subscribe(result => {
      const data = result as CommonDDL;
      this.accountNoList = data.accounts;
    }, error => LolLoggerService.error(error)));
  }

  // Reset Audit Filter
  resetAuditFilter() {
    this.productFilters = {
      'CompanyCode': this.headerCompany,
      'CropYear': this.headerYear,
      'ItemNo': [],
      'OrderNo': null,
      'ChangeQty': null,
      'Brand': null,
      'MarketingBrandList': [],
      'SeedSizeList': [],
      'PackageSizeList': [],
      'TechnologyList': null,
      'TreatmentList': [],
      'AccountName': null,
      'TxtAccountNo': null,
      'AccountNo': [],
      'ProductLineList': [],
      'FromDate': null,
      'ToDate': null,
      'City': null,
      'releases': null,
      'BranchPlantList': [],
      'RequestTypeList': [],
      'ExplanationList': [],
      'DOTTransactionID': null,
      'UserID': null,
      'ERPOrderNumber': null
    };

    this.filter = {
      'companyCode': this.headerCompany,
      'cropYear': this.headerYear,
      'itemNo': null,
      'orderNo': null,
      'changeQty': null,
      'productName': null,
      'marketingBrand': null,
      'seedSize': null,
      'packageSize': null,
      'technology': null,
      'treatment': null,
      'accountName': null,
      'account': null,
      'productLine': null,
      'fromDate': null,
      'toDate': null,
      'evolveAccountRestriction': null,
      'userId': null,
      'includeChangeQtyZero': null,
      'changeQtyAction': null,
      'city': null,
      'releases': null,
      'branchPlant': null,
      'requestType': null,
      'dotTransactionID': null,
      'explanation': null,
      'erpOrderNumber': null
    };
  }

  // Clear filter
  clearFilter(filterValue) {
    const index = this.filterValueList.indexOf(filterValue);
    this.searchValue = '';
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      // remove product filter
      this.removeAuditFilter(filterValue);

      if (this.filterValueList.length < 1) {
        this.releaseItemsAuditDataSource = new MatTableDataSource([]);
        this.releaseItemsAuditDataSource.paginator = this.productPaginator;
        this.releaseItemsAuditDataSource.sort = this.productSort;
      }
      this.enableDisableSearch();
    }
  }

  // To remove clear search filter
  removeAuditFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    const index = -1;
    switch (removeFilter[0].trim()) {
      case 'Item No':
        this.productFilters.ItemNo = null;
        this.filter.itemNo = null;
        break;
      case 'Order No':
        this.productFilters.OrderNo = null;
        this.filter.orderNo = null;
        break;
      case 'Change Qty':
        this.productFilters.ChangeQty = null;
        this.filter.changeQty = null;
        this.filter.changeQtyAction = null;
        break;
      case 'Product Name':
        this.productFilters.Brand = null;
        this.filter.productName = null;
        break;
      case 'Marketing Brand':
        this.productFilters.MarketingBrandList = [];
        this.filter.marketingBrand = null;
        break;
      case 'Seed Size':
        this.productFilters.SeedSizeList = [];
        this.filter.seedSize = null;
        break;
      case 'Package Size':
        this.productFilters.PackageSizeList = [];
        this.filter.packageSize = null;
        break;
      case 'Branch Plant':
        this.productFilters.BranchPlantList = [];
        this.filter.branchPlant = null;
        break;
      case 'Releases':
        this.productFilters.Releases = null;
        this.filter.releases = null;
        break;
      case 'Request Type':
        this.productFilters.RequestTypeList = [];
        this.filter.requestType = null;
        break;
      case 'Technology':
        this.productFilters.TechnologyList = null;
        this.filter.technology = null;
        break;
      case 'Treatment':
        this.productFilters.TreatmentList = [];
        this.filter.treatment = null;
        break;
      case 'Account No':
        if (this.isEvolveAccountRestriction) {
          this.productFilters.AccountNo = [];
        }
        else {
          this.productFilters.TxtAccountNo = null;
        }
        this.productFilters.AccountNo = [];
        this.filter.account = null;
        break;
      case 'Account':
        if (this.isEvolveAccountRestriction) {
          this.productFilters.AccountNo = [];
        }
        else {
          this.productFilters.TxtAccountNo = null;
        }
        this.productFilters.AccountNo = [];
        this.filter.account = null;
        break;
      case 'Account Name':
        this.productFilters.AccountName = null;
        this.filter.accountName = null;
        break;
      case 'City':
        this.productFilters.City = null;
        this.filter.city = null;
        break;
      case 'Product Line':
        this.productFilters.ProductLineList = [];
        this.filter.productLine = null;
        break;
      case 'DOTTransaction ID':
        this.productFilters.DOTTransactionID = null;
        this.filter.dotTransactionID = null;
        break;
      case 'ERP Order Number':
        this.productFilters.ERPOrderNumber = null;
        this.filter.erpOrderNumber = null;
        break;
      case 'Explanation':
        this.productFilters.ExplanationList = [];
        this.filter.explanation = null;
        break;
      case 'User ID':
        this.productFilters.UserID = null;
        this.filter.userId = null;
        break;
      case 'Duration':
        this.productFilters.FromDate = null;
        this.productFilters.ToDate = null;
        this.filter.fromDate = null;
        this.filter.toDate = null;
        this.fromDateFilter = '';
        this.toDateFilter = '';
        break;
      default:
        break;
    }
  }

  // Clear all filter
  clearAllFilter() {
    this.filterValueList = new Array();
    this.searchValue = '';
    this.isTextBoxEmpty = true;
    this.resetAuditFilter();
    this.validateDateFilter('clearAll', '');
    this.releaseItemsAuditDataSource = new MatTableDataSource([]);
    this.releaseItemsAuditDataSource.paginator = this.productPaginator;
    this.releaseItemsAuditDataSource.sort = this.productSort;
    // To Do clear grid
  }

  // Search the account details on Account dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  // Get release items audit
  getReleaseItemsAuditLog() {
    if (!this.validateInputText()) {
      return false;
    }

    if ((this.filter.account == '-1') && (!this.filter.productName || this.filter.productName == '')
      && (!this.filter.itemNo || this.filter.itemNo != '')) {
      this.toastrService.error('Please specify a Product Name or Item Code before initiating a Search');
      return false;
    }

    // Set change Qty to -1 if change Action not selected
    if (!this.productFilters.ChangeQty || this.productFilters.ChangeQty == null) {
      this.filter.changeQty = -1;
    }
    if (!this.filter.evolveAccountRestriction) {
      this.filter.evolveAccountRestriction = false;
    }
    if (!this.filter.includeChangeQtyZero) {
      this.filter.includeChangeQtyZero = false;
    }

    this.loaderService.setLoaderStatus(true);
    this.filter.evolveAccountRestriction = this.isEvolveAccountRestriction;

    this.subscription.push(this.releaseItemsAuditService.getReleaseItemsAudit(this.filter).subscribe((result: any) => {
      if (result) {
        this.releaseItemsAuditList = result;
        this.releaseItemsAuditDataSource = new MatTableDataSource(this.releaseItemsAuditList);
        this.releaseItemsAuditDataSource.paginator = this.productPaginator;
        this.releaseItemsAuditDataSource.paginator.firstPage();
        this.releaseItemsAuditDataSource.sort = this.productSort;
      }
      this.loaderService.setLoaderStatus(false);
    }, (error) => {
      this.loaderService.setLoaderStatus(false);
      LolLoggerService.error(error);
    }));
  }

  // Export excel
  export() {
    const exportData = [];
    if (this.releaseItemsAuditDataSource && this.releaseItemsAuditDataSource.data.length > 0) {
      this.loaderService.setLoaderStatus(true);
      this.releaseItemsAuditDataSource.data.forEach(x => {
        exportData.push({
          'Product': (x.brand == undefined ? '' : x.brand + ' - ') + (x.marketingBrandDescription == undefined ? '' : x.marketingBrandDescription + ' - ') + (x.itemDescription == undefined ? '' : x.itemDescription + '  '),
          'Item Number': x.itemNumber,
          'Audit Time': this.datePipe.transform(x.auditTime, 'MM-dd-yyyy h:mm:ss a'),
          'Release Number': x.releaseID,
          'Account Name': x.accountName,
          'Account Number': x.accountNumber,
          'Account City': x.city,
          'Quantity': x.quantity,
          'ChangeQty': x.changeQty,
          'Modified By': x.updatedBy,
          'Branch Plant': x.branch,
          'Request Type': x.requestType,
          'Explanation': x.explanation,
          'Action': x.action,
          'DOT TransactionId': x.dotTransactionId,
          'ERP Order #': x.erpOrderNumber > 0 ? x.erpOrderNumber : '',
          'Seed Size': x.seedSizeDescription,
          'Package Size': x.packageSizeDescription,
          'Treatment': x.treatmentDescription
        });
      });
      this.excelService.exportAsExcelFile(exportData, 'ReleaseItemsAuditReport');
      this.loaderService.setLoaderStatus(false);
    }
  }

  // validate the To and From date for Duration filter
  validateDateFilter(contextFrom, $event) {
    if (contextFrom == 'fromDate') {
      fromDate = new Date($event.value);
      if (this.productFilters.ToDate) {
        var toDate = new Date(this.productFilters.ToDate);
        this.fromDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate <= toDate;
        };
      }
      this.toDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate >= fromDate;
      };
    }
    else if (contextFrom == 'toDate') {
      toDate = new Date($event.value);
      this.fromDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate <= toDate;
      };
      if (this.productFilters.FromDate) {
        var fromDate = new Date(this.productFilters.FromDate);
        this.toDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate >= fromDate;
        };
      }
    }
    else if (contextFrom == 'clearAll') {
      this.fromDateFilter = '';
      this.toDateFilter = '';
    }
  }
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccSummaryTableHeight();
  }

  // set table height
  setAccSummaryTableHeight() {
    setTimeout(function () {
      const templateHeight = window.innerHeight - $('h3').outerHeight() - $('.form-sec').outerHeight() - $('.fulfill-top-sec').outerHeight() - 120;
      $('.itemAuditTable').css('max-height', templateHeight + 'px');
    }, 100);
  }
}
